import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createContact, getContacts } from "../../../services/contact";
import toast from "react-hot-toast";

function useContact() {
  const queryClient = useQueryClient();
  const createContactMutation = useMutation({
    mutationFn: (contactData) => createContact(contactData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      toast.success("Contact has been created");
    },
    onError: (error) => {
      toast.error("Failed to create contact");
    },
  });

  const contactData = useQuery({
    queryKey: ["contacts"],
    queryFn: () => getContacts(),
  });

  return {
    createContactFn: createContactMutation.mutate,
    isCreatingContact: createContactMutation.isLoading,
    contactData: contactData.data,
    isLoadingContacts: contactData.isLoading,
    isErrorContacts: contactData.isError,
  };
}

export default useContact;
